import React from 'react';
import { PieChart, Pie, Cell, Legend } from 'recharts';
import PropTypes from 'prop-types';

import './product-classifications-pie-chart.scss';

const ProductClassificationsPieChart = ({ dealRoomStatistics }) => {
  const { dealClassificationsVO } = dealRoomStatistics;

  const colors = ['#D949BC', '#4BCEC0', '#74D962', '#EEEE74', '#E88484', '#6363DB'];

  let isNoDataToDisplay = true;
  for (let i = 0; i < dealClassificationsVO.length; i++) {
    if (dealClassificationsVO[i].value !== 0) {
      isNoDataToDisplay = false;
      break;
    }
  }

  const data = dealClassificationsVO.filter((entry) => entry.value !== 0);

  if (isNoDataToDisplay) {
    return (
      <section className="product-classifications-pie-chart">
        <p className="product-classifications-pie-chart__no-data">No data to display</p>
      </section>
    );
  }

  return (
    <section className="product-classifications-pie-chart">
      <PieChart width={500} height={250}>
        <Pie
          data={data}
          nameKey="name"
          dataKey="value"
          outerRadius={110}
          legendType="square"
          isAnimationActive={false}
          labelLine={false}
          label={({ cx, cy, midAngle, innerRadius, outerRadius, value, percent }) => {
            const RADIAN = Math.PI / 180;
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN) + 5;
            const y = cy + radius * Math.sin(-midAngle * RADIAN) + 5;

            return (
              <text x={x} y={y} fill="#262626" textAnchor="end" fontSize="18" fontWeight="500">
                {percent * 100 > 5 ? value : ''}
              </text>
            );
          }}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index]} />
          ))}
        </Pie>
        <Legend layout="vertical" verticalAlign="middle" align="right" />
      </PieChart>
    </section>
  );
};

ProductClassificationsPieChart.propTypes = {
  dealRoomStatistics: PropTypes.shape({}).isRequired,
};

export default ProductClassificationsPieChart;
